import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import CancelClass from "./Cancel.module.css";
import { useForm } from "react-hook-form";
import { Services } from "../../Services";
import Select from "react-select";
import Classes from "./Classes";
import Swal from "sweetalert";
import Loader from "Components/loader/loader";
import { useSearchParams, useLocation } from "react-router-dom";
import { warningSwal } from "Util/Toast";
import Popup from "./popup";
function Cancel() {
    const location = useLocation();
    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);
    const [tutors, setTutors] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchparams, setsearchparams] = useSearchParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [dates, SetDates] = useState({ FromDate: "", ToDate: "" });
    const [joiningDate, setJoiningDate] = useState("");
    const [tutorSearchString, setTutorSearchString] = useState(null);
    const [selectedTutor, setSelectedTutor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [optionData, setOptionData] = useState([]);
    const [tutorSearchLoad, setTutorSearchLoad] = useState(false);
    const [cancelLoad, setcancelLoad] = useState(false);
    const [config, setConfig] = useState([]);

    // const { id } = useParams();
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm();
    const watchData = watch();
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (
                typeof tutorSearchString == "string" &&
                tutorSearchString.length > 0
            ) {
                setTutorSearchLoad(true);

                try {
                    const data = await Services.searchActiveTutor(
                        "POST",
                        JSON.stringify({ SearchString: tutorSearchString }),
                        token,
                        selectedTutor
                    );
                    const formattedOptions = data.Tutors.map((tutor) => ({
                        label: `${tutor.FirstName} ${tutor.LastName}`,
                        value: tutor.TutorID,
                    }));
                    setTutors([
                        ...formattedOptions,
                        { label: "ALL", value: "ALL" },
                    ]);
                    setOptionData(data.Tutors);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setTutorSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [tutorSearchString]);
    useEffect(() => {
        const FromDate = searchparams.get("FromDate");
        const ToDate = searchparams.get("ToDate");
        if (FromDate && ToDate) {
            setValue("FromDate", FromDate);
            setValue("ToDate", ToDate);
            let body = {
                FromDate: FromDate,
                ToDate: ToDate,
            };
            fetchClasses(body);
        }
        getConfig();
    }, []);
    const getConfig = () => {
        Services.get_config("GET", null, token)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setConfig(response.Configuration);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const fetchClasses = async (data) => {
        setLoading(true);
        SetDates(data);
        try {
            const Response = await Services.getScheduled_class_by_date(
                "POST",
                JSON.stringify(data),
                token
            );

            if (Response.Status === 1) {
                setData(Response.ScheduleClasess);
                if (
                    Response?.ScheduleClasess &&
                    Response.ScheduleClasess?.length > 0
                ) {
                    setSelectedRows(
                        Response?.ScheduleClasess?.map(
                            (item) => item.ScheduleClassID
                        )
                    );
                }
                setErrorMessage("");
            } else {
                Error(Response.Message);
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            Error("something went wrong please try again");
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        setsearchparams({ ...data, TutorID: selectedTutor?.value });

        fetchClasses({ ...data, TutorID: selectedTutor?.value });
    };

    const handleChange = (selectedOption) => {
        setTutorSearchString(selectedOption);
    };
    const onTutorSelect = (option) => {
        if (option) {
            setSelectedTutor(option);
            let selectedTutor = optionData?.find(
                (item) => item.TutorID == option.value
            );
            setJoiningDate(selectedTutor.JoinedDate);
        }
    };
    const handleCheckboxChange = (id) => {
        if (selectedRows.includes(id)) {
            setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
        } else {
            setSelectedRows([...selectedRows, id]);
        }
    };
    const handleSelectAll = () => {
        const allIds = data.map((item) => item.ScheduleClassID);

        if (selectedRows.length === allIds.length) {
            setSelectedRows([]);
        } else {
            setSelectedRows(allIds);
        }
    };
    function getDatesBetween(fromDate, toDate) {
        const datesArray = [];
        const currentDate = new Date(fromDate);
        const endDate = new Date(toDate);

        while (currentDate <= endDate) {
            datesArray.push(currentDate.toISOString().split("T")[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return datesArray;
    }
    const cancel = async (formData) => {
        setcancelLoad(true);
        console.log(selectedRows);
        try {
            const Response = await Services.bulk_cancel_tutor(
                "POST",
                JSON.stringify({
                    ...formData,
                    JoinedDate: joiningDate,
                    ScheduleClassIDs: selectedRows,
                    // ScheduleClassIDs: data.map(
                    //     (item: any) => item.ScheduleClassID
                    // ),
                    TutorID: selectedTutor?.value,
                    ClassesCount: selectedRows.length,
                    FromDate: watchData.FromDate,
                    ToDate: watchData.ToDate,
                    Dates: getDatesBetween(
                        watchData.FromDate,
                        watchData.ToDate
                    ),
                }),
                token
            );

            if (Response.Status === 1) {
                setModal(false);
                setsearchparams({});
                setData([]);
                reset({ FromDate: "", ToDate: "" });
                Swal({
                    title: "Class Cancelled",

                    icon: "success",
                });
                setErrorMessage("");
            } else {
                // Error(Response.Message);
                setErrorMessage(Response.Message);
            }
        } catch (err) {
            console.log(err);
            // setModal(false);
            Error("something went wrong please try again");
        } finally {
            setcancelLoad(false);
        }
    };
    console.log(selectedRows);
    return (
        <Layout
            Active={
                String(location.pathname).includes("Public_holiday")
                    ? "Public Holiday"
                    : "Requested by teacher"
            }>
            {modal && (
                <Popup
                    modal={modal}
                    setModal={setModal}
                    getDetails={cancel}
                    classes={data}
                    cancelLoad={cancelLoad}
                    dates={dates}
                    erroMsg={errorMessage}
                    selectedRows={selectedRows}
                    setErrorMessage={setErrorMessage}
                    config={config}
                    setcancelLoad={setcancelLoad}
                    main={
                        String(location.pathname).includes("Public_holiday")
                            ? "Public Holiday"
                            : "Requested by teacher"
                    }
                />
            )}
            <Helmet>
                <meta charSet="utf-8" />
                <title>Class Details</title>
            </Helmet>
            {cancelLoad && <Loader />}

            <div className={CancelClass["Container"]}>
                <div className={CancelClass["wrapper"]}>
                    <h3>Tutor Cancel Classes</h3>

                    <>
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className={CancelClass["date-filter"]}>
                            <div className={CancelClass["form_control"]}>
                                <label htmlFor="">Tutor</label>
                                <Select
                                    options={tutors}
                                    onInputChange={handleChange}
                                    onChange={onTutorSelect}
                                    value={selectedTutor}
                                    isLoading={tutorSearchLoad}
                                    placeholder="Search Tutor"
                                    noOptionsMessage={() => "No Tutor Found"}
                                    classNames={CancelClass["select"]}
                                    styles={{
                                        // Set the width to 100%
                                        control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                        }),
                                    }}
                                />
                            </div>
                            <div className={CancelClass["form-control"]}>
                                <label htmlFor="">From Date</label>
                                <input
                                    type="date"
                                    /*   min={new Date().toISOString().split("T")[0]} */
                                    {...register("FromDate", {
                                        required: "this field is required",
                                        onChange: (e) => {
                                            setData([]);
                                        },
                                    })}
                                />
                            </div>
                            <div className={CancelClass["form-control"]}>
                                <label htmlFor="">To Date</label>
                                <input
                                    type="date"
                                    /*    min={new Date().toISOString().split("T")[0]} */
                                    {...register("ToDate", {
                                        required: "this field is required",
                                        onChange: (e) => {
                                            setData([]);
                                        },
                                    })}
                                />
                                {/* {errors.FromDate && (
                                    <span>{errors.FromDate.message}</span>
                                )} */}
                            </div>
                            <button>Search</button>
                        </form>
                        <Classes
                            Loading={loading}
                            classesData={data}
                            handleCheckboxChange={handleCheckboxChange}
                            handleSelectAll={handleSelectAll}
                            rowSelect={true}
                            selectedRows={selectedRows}
                        />

                        <button
                            className={CancelClass["cancel"]}
                            onClick={() => {
                                setModal(true);
                            }}
                            disabled={data.length === 0}>
                            {" "}
                            Cancel Classes
                        </button>
                    </>
                </div>
            </div>
        </Layout>
    );
}

export default Cancel;
